/* Une présentation par visite (onglet), uniquement sur l’accueil Shopify. */
(() => {
  const storageKey = 'dulce-promotion-fete-du-travail-2026';
  const editor = Boolean(window.Shopify?.designMode);

  const initialize = () => {
    const dialog = document.querySelector('[data-promotion-popup]');
    if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
    dialog.dataset.initialized = 'true';

    if (!editor) {
      try {
        if (sessionStorage.getItem(storageKey)) return;
      } catch (_) {
        // La promotion reste accessible si le stockage est désactivé.
      }
    }

    const close = () => dialog.close();
    dialog.querySelector('.promotion-popup__close').addEventListener('click', close);
    dialog.querySelector('.promotion-popup__link').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('promotion-popup-open');
    });

    dialog.showModal();
    document.documentElement.classList.add('promotion-popup-open');
    if (!editor) {
      try { sessionStorage.setItem(storageKey, 'seen'); } catch (_) {}
    }
  };

  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-promotion-popup]')) {
      document.documentElement.classList.remove('promotion-popup-open');
    }
  });
})();
